export const RELAY_PATH = '/dubbletrack-sync';
export const ENVELOPE = 'dubbletrackSync';

// Browsers partition a third-party frame's storage and BroadcastChannel by the top-level
// site, so the relay only reaches the player when both share a registrable domain. Two
// labels is an approximation that is right for every station domain we expect.
export function sameSite(originA, originB) {
  let hostA = hostnameOf(originA);
  let hostB = hostnameOf(originB);
  if (!hostA || !hostB) {
    return false;
  }
  let site = (host) => host.split('.').slice(-2).join('.');
  return site(hostA) === site(hostB) || hostA.endsWith(`.${hostB}`) || hostB.endsWith(`.${hostA}`);
}

// An opaque origin arrives as the string "null".
function hostnameOf(origin) {
  try {
    return new URL(origin).hostname;
  } catch {
    return null;
  }
}

// BroadcastChannel stops at the origin, so a page on the station's site reaches a player
// on its own domain through a hidden frame of that domain, which sits on the channel there.
export class SyncRelay {
  _frame = null;
  _origin = null;
  _ready = false;
  _queued = [];
  _onMessage = null;
  _messageHandler = null;

  constructor(playerUrl, onMessage) {
    this._origin = new URL(playerUrl).origin;
    this._onMessage = onMessage;

    this._messageHandler = (event) => {
      if (event.origin !== this._origin || event.source !== this._frame?.contentWindow) return;
      let data = event.data?.[ENVELOPE];
      if (!data) return;
      if (data.type === 'relay-ready') {
        this._ready = true;
        this._queued.splice(0).forEach((message) => this.post(message));
        return;
      }
      this._onMessage(data);
    };
    window.addEventListener('message', this._messageHandler);

    let frame = document.createElement('iframe');
    frame.src = `${this._origin}${RELAY_PATH}?origin=${encodeURIComponent(window.location.origin)}`;
    frame.setAttribute('aria-hidden', 'true');
    frame.setAttribute('tabindex', '-1');
    frame.style.cssText = 'position:absolute;width:0;height:0;border:0;visibility:hidden;';
    document.body.appendChild(frame);
    this._frame = frame;
  }

  get origin() {
    return this._origin;
  }

  post(message) {
    if (!this._ready) {
      this._queued.push(message);
      return;
    }
    this._frame?.contentWindow?.postMessage({ [ENVELOPE]: message }, this._origin);
  }

  destroy() {
    window.removeEventListener('message', this._messageHandler);
    this._frame?.remove();
    this._frame = null;
  }
}
